import * as CryptoJSLib from "crypto-js";
import { Env } from "./globalUtilities";
class CryptoJs {
  secretKey = (Env().REACT_APP_ENCODE as string)?.replace(
    /KEYGEN/g,
    btoa("KEYGEN")
  );

  encrypt(data: string) {
    var ciphertext = CryptoJSLib.AES.encrypt(data, this.secretKey).toString();
    return ciphertext;
  }

  decrypt(ciphertext: string) {
    var bytes = CryptoJSLib.AES.decrypt(ciphertext, this.secretKey);
    var originalText = bytes.toString(CryptoJSLib.enc.Utf8);
    return originalText;
  }

  hashFromText(plaintextPassword: string) {
    const hashedPassword = CryptoJSLib.SHA256(plaintextPassword).toString();
    return hashedPassword;
  }

  encryptTextWithCustomPasswrd(text: string, key: string) {
    return CryptoJSLib.AES.encrypt(text, key).toString();
  }

  decryptTextWithCustomPasswrd(ciphertext: string, key: string) {
    var bytes = CryptoJSLib.AES.decrypt(ciphertext, key);
    var originalText = bytes.toString(CryptoJSLib.enc.Utf8);
    return originalText;
  }
}

export default CryptoJs;
